module.exports = __webpack_public_path__ + "static/media/plane.ecf75ad8.svg";